import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { loginWebBox, loginWeb, loginWebWrapper } from './LoginWeb.styles';
import { SignIn } from '../SignIn/SignIn';
import { ResetPassword } from '../ResetPassword/ResetPassword';
import { SetPassword } from '../SetPassword/SetPassword';
import { AuthPageLeftPanel } from '../AuthPageLeftPanel/AuthPageLeftPanel';
import { VerifyYourEmail } from '../VerifyYourEmail/VerifyYourEmail';
export var LoginWebMode;
(function (LoginWebMode) {
    LoginWebMode["SIGNIN"] = "signin";
    LoginWebMode["EMAIL_FORM"] = "email_form";
    LoginWebMode["PASSWORD_FORM"] = "password_form";
    LoginWebMode["NOT_VERIFIED"] = "not_verified";
})(LoginWebMode || (LoginWebMode = {}));
export function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (_jsx(Box, { role: 'tabpanel', hidden: value !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}`, ...other, children: value === index && (_jsx(Box, { children: _jsx(Typography, { component: 'div', children: children }) })) }));
}
export const LoginWeb = ({ signUpHidden, handleSSO, handleSignIn, handleSignUp, handleResendVerifyEmail, signUpSuccess, handleResetPassword, mode, handleSignInRedirect, handleSignUpRedirect, handleSendLink, handleSetPasswordSubmit, sendLinkSuccess, setPasswordSuccess, handlePasswordValidation, error, clearError, emailFromSignUp, signInEmail, captchaVisible, recaptchaComponent }) => {
    function onSigninSuccess() {
        if (signUpHidden) {
            const a = document.createElement('a');
            a.href = process.env.REACT_APP_PESC_URL;
            a.click();
        }
        handleSignUp?.();
    }
    const signInProps = {
        signInSuccess: onSigninSuccess,
        handleSSO,
        handleSignIn,
        handleResetPassword,
        mode,
        emailFromSignUp: signUpSuccess?.email || emailFromSignUp,
        error,
        clearError,
        captchaVisible,
        recaptchaComponent
    };
    const resetPasswordProps = {
        handleSignInRedirect,
        handleSignUpRedirect,
        handleSendLink,
        sendLinkSuccess,
        signUpHidden,
        captchaIndex: captchaVisible?.index ?? 0,
        recaptchaComponent
    };
    const setPasswordProps = {
        submit: handleSetPasswordSubmit,
        setPasswordSuccess,
        handleSignInRedirect,
        handlePasswordValidation,
        clearError,
        error
    };
    const renderContent = useMemo(() => {
        switch (mode) {
            case LoginWebMode.EMAIL_FORM:
                return _jsx(ResetPassword, { ...resetPasswordProps });
            case LoginWebMode.PASSWORD_FORM:
                return _jsx(SetPassword, { ...setPasswordProps });
            case LoginWebMode.NOT_VERIFIED:
                return _jsx(VerifyYourEmail, { verifyEmailAction: handleResendVerifyEmail, email: signInEmail });
            case LoginWebMode.SIGNIN:
            default:
                return _jsx(SignIn, { ...signInProps });
        }
    }, [
        mode,
        resetPasswordProps,
        setPasswordProps,
        handleResendVerifyEmail,
        signInEmail,
        signInProps
    ]);
    return (_jsx(Box, { component: 'section', sx: loginWeb, children: _jsx(Box, { sx: loginWebWrapper, children: _jsxs(Grid, { columnSpacing: 2, container: true, children: [_jsx(Grid, { item: true, display: { mobile: 'none', desktop: 'block' }, desktop: 6, children: _jsx(AuthPageLeftPanel, { type: 'login' }) }), _jsx(Grid, { item: true, mobile: 12, desktop: 6, children: _jsx(Box, { sx: loginWebBox, children: _jsx(TabPanel, { value: 1, index: 1, children: renderContent }) }) })] }) }) }));
};
//# sourceMappingURL=LoginWeb.js.map